import SearchableDropdown from '../../../common/SearchableDropdown';
import { BaseControl } from '.';

/**
 * @typedef {object} SelectOption
 * @property {string} value - Value of the option
 * @property {string} label - Display label for the option
 */

/**
 * @typedef {object} SelectControlOptions
 * @property {SelectOption[]} [choices] - Available select dropdown items
 * @property {boolean} [allowSearch] - Whether to show a search input for filtering options
 */

/**
 * @extends {BaseControl<string, SelectControlOptions>}
 */
export class SelectControl extends BaseControl {

    /** @type {BaseControl<string>['render']} */
    render(value, onChange) {
        return (
            <SelectControlRenderer 
                value={value} 
                onChange={onChange} 
                control={this}
            />
        );
    }
}

/**
 * @param {object} props
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {SelectControl} props.control
 * @param {SelectOption[]} [props.choices] - Overrides `control.options.choices` (e.g. re-ordered for the report's deelnemer)
 * @returns {JSX.Element}
 */
export const SelectControlRenderer = ({ control, value, onChange, choices }) => {

    const allChoices = choices || control.options.choices || [];
    const allowSearch = control.options.allowSearch || false;

    if (allowSearch) {
        return (
            <div className="select-control select-control--searchable">
                <span className="select-control-label">
                    {control.label}
                </span>
                <SearchableDropdown
                    options={allChoices}
                    value={value}
                    onChange={onChange}
                    allowSearch
                />
                {control.description && (
                    <p className="select-control-description">
                        {control.description}
                    </p>
                )}
            </div>
        );
    }

    return (
        <div className="select-control">
            <div className="select-control-header">
                <label className="select-control-label">
                    {control.label}
                </label>
                <SearchableDropdown
                    options={allChoices}
                    value={value}
                    onChange={onChange}
                />
            </div>
            {control.description && (
                <p className="select-control-description">
                    {control.description}
                </p>
            )}
        </div>
    );
}
